import { styled } from '@mui/material/styles';
import React, { ButtonHTMLAttributes } from 'react';
import colors from 'src/utils/colors';

const AuthButtonInner = styled('button')({
  height: '47px',
  borderRadius: '24px',
  backgroundColor: colors.darkBlue,
  color: 'white',
  fontSize: '18px',
  fontWeight: 600,
  border: 'none',
  fontFamily: 'Geist',
  width: '100%'
});

const AuthButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = (props) => {
  return <AuthButtonInner id="signin-button" {...props} />;
};

export default AuthButton;
